import { render, staticRenderFns } from "./FolderTreeNode.vue?vue&type=template&id=0596584a&scoped=true&"
import script from "./FolderTreeNode.vue?vue&type=script&lang=js&"
export * from "./FolderTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./FolderTreeNode.vue?vue&type=style&index=0&id=0596584a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596584a",
  null
  
)

export default component.exports